import { render, staticRenderFns } from "./EvaluacionesComponent.vue?vue&type=template&id=4265e1d2"
import script from "./EvaluacionesComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports